import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { DateFunctions } from "../static/date-functions";
import { CommonValues } from "../static/CommonValues";

export class OrderDetailsBus extends BaseBus
{
    constructor(data: OrderDetailsBus = null) {
        super(data);
    }
    CID(): any {
        return this.orderDetailId;
    }
    setId(id: any) {
        this.orderDetailId = id;
    }
    setParentId(id: any) {
        this.orderId = id;
    }
    initialize(data: OrderDetailsBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.mobileAuthDate = CommonFunctions.getDate(data.mobileAuthDate);
            this.sageDt = CommonFunctions.getDate(data.sageDt);
            this.usedPartChngDt = CommonFunctions.getDate(data.usedPartChngDt);
        }
        catch {

        }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.insertDt = date;
        this.updateDt = date;
        this.insertUserId = userId;
        this.updateUserId = userId;
    }
    setFromForm(data: OrderDetailsBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    changeInventoryItem(data: v_InventoryBus, updateExistingQuantities: boolean = true,customerId:string= null) {
        this.inventoryNumber = data.number;
        this.manufacturerNumber = data.manufacturerNumber;
        this.inventoryDesc = data.inventoryDesc;

        this.ratio = data.ratio;
        if (updateExistingQuantities) {
            this.quantityReceived = 0;
            this.quantity = 1;
            this.usedPartQuantity = 0;
        } else {
            this.quantityReceived = this.quantityReceived;
            this.quantity = this.quantity;
            this.usedPartQuantity = this.usedPartQuantity;
        }
        this.price = 0;
        this.isPart = data.isPart;
        this.inventoryId = data.inventoryId;
        this.inventoryLocationId = null;
        if ((this.isPart || data.billingTypeId === CommonValues.BillingType_NonInventoryPart ) && customerId != CommonValues.CustomerId_ClimatePros) {
            this.warehouseId = CommonValues.InventoryLocation_StagingWarehouse;
        }

    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

        this.mobileAuthDate = DateFunctions.getDateTimeWithUTCOffset(this.mobileAuthDate);
        this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
        this.usedPartChngDt = DateFunctions.getDateTimeWithUTCOffset(this.usedPartChngDt);
    }
    calculateTotals() {
        var markUpRatio = 1
        var marginRatio = 1
        if (this.markUp) {
            markUpRatio = markUpRatio + (this.markUp / 100);
        }
        if (this.margin) {
            marginRatio = (1 / (1-(this.margin / 100)));
        }
        let price: number = CommonFunctions.RoundToPrecision(this.price, 3);
        this.amount = CommonFunctions.RoundToPrecision((this.quantity * this.price * markUpRatio * marginRatio), 2);
    }
    /***************************
     * orderDetailId
     *
     *
    ****************************/
    orderDetailId: any;
    orderId: any;
    inventoryId: any;
    dispatchId: any;
    quantity: number;
    locationQuantity: number;
    allQuantity: number;
    price: number;
    amount: number;
    accountClassId: any;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    inventoryDesc: string;
    isWrongPart: boolean;
    viewedInMobile: boolean;
    mobileAuthDate: Date;
    mobileAuthUserId: any;
    toBeReturned: boolean;
    warehouseId: any;
    deliveryWarehouseId: any;
    warehouseName: any;
    cpWarehouseName: any;
    usedPartQuantity: number;
    onConstDraw: boolean;
    pmapprovalId: any;
    sageDt: Date;
    usedPartChngId: any;
    usedPartChngDt: Date;
    maxCost: number;
    zuggitMaxCost: number;
    inventoryNumber: string;
    dispatchNumber: string;
    orderReceiveDetailId: any;
    inventoryLocationId: any;
    quantityReceived: number;
    totalReceived: number;
    manufacturerNumber: string;
    supplierId: any;
    ratio: number;
    ratioXQty: number;
    ratioCp: number;
    ratioXQtyCp: number;
    isPart: boolean;
    vendorNbr: string;
    removeDispatchPartsRequestId: any;
    //Not sure where these come from or do
    quantityBilled: number
    acknowledged: boolean;
    replace: boolean;
    isConstruction: boolean;
    markUp: number;
    invoiceMarkUp: number;
    margin: number;
    contractPrice: number;
    quantityInvoiced: number;
    costVerifyThreshold: number;
    orderPriceOverideReasonId: any;
    orderPriceOverideOtherReason: string;
    serialNumber: string;
    get invoiceMarkUpPercent(): number {
        return this.invoiceMarkUp * 100;
    }
    set invoiceMarkUpPercent(value: number) {
        this.invoiceMarkUp = CommonFunctions.RoundToPrecision(value / 100, 4);
    }
}
